import dayjs from 'dayjs';
import { splitPhoneNumber } from 'src/components/Form/FormGenerator/utils/splitPhoneNumber';

import { findCountryCodeByName } from 'src/utils';

/** Получает объект на вход и из него создает боди для запроса update-profile */
export const prepareDataToProfile = ({
  name,
  surname,
  birthday,
  postcode,
  country,
  city,
  phone,
  address
}: {
  name?: string;
  surname?: string;
  birthday?: string;
  postcode?: string;
  country?: string;
  city?: string;
  phone?: string;
  address?: string;
}) => {
  let phoneCode = '';
  let phoneNumber = '';
  const countryCode = findCountryCodeByName(country);

  if (phone) {
    const phoneParsed = splitPhoneNumber('+' + Number(phone.replace(/\s+/g, '')));
    phoneCode = phoneParsed.code || '';
    phoneNumber = phoneParsed.phone || '';
  }

  return {
    name: name ? name.replace(/' '/g, '') : undefined,
    surname: surname ? surname.replace(/' '/g, '') : undefined,
    birthday: birthday ? dayjs(birthday).format('YYYY-MM-DD') : undefined,
    country: country ? countryCode?.replace(/' '/g, '') : undefined,
    postcode: postcode ? postcode.replace(/' '/g, '') : undefined,
    city: city ? city.replace(/' '/g, '') : undefined,
    address: address ? address.replace(/' '/g, '') : undefined,
    code: phoneCode || undefined,
    phone: phoneNumber || undefined
  };
};
